import { useAppSelector } from 'app/store';
import { ROLE_TENANT_TECHNICIAN } from './../../constants';

export function isTechnician(): boolean {
  const groups = useAppSelector((state) => state.auth.groups);
  return groups?.includes(ROLE_TENANT_TECHNICIAN) ?? false;
}
